import { ServicePackage } from 'src/apis/monolith/types';
import { object, string } from 'yup';

export type SelectServicePackageStepData = {
  servicePackage: ServicePackage;
};

export type DebtorDetailsFormData = {
  companyName: string;
  debtorStreet: string;
  debtorZipCode: string;
  debtorCity: string;
  debtorCountry: string;
  vatNumber: string;
  iban: string;
  bic: string;
};

export const DebtorDetailsFormSchema = object({
  companyName: string().required(),
  debtorStreet: string().required(),
  debtorZipCode: string().required(),
  debtorCity: string().required(),
  debtorCountry: string().required(),
  vatNumber: string().required(),
  iban: string().required(),
  bic: string().required(),
}).defined();

export type ProvideSEPAMandateStepData = {
  formData: DebtorDetailsFormData;
  confirmed: boolean;
};

export type ConfirmationStepData = { confirmed: boolean };
